import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

@Entity()
export class AppFeedback extends MongoEntity {
  static override _class = 'AppFeedback';
  static override _collectionName = 'app_feedback';

  @Field(() => String)
  userId!: string;

  @Field(() => String)
  type!: string;

  @Field(() => String)
  message!: string;

  @Field(() => [String])
  imageFileIds: Maybe<string[]>;

  @Field(() => String)
  timestamp!: string;

  @Field(() => String)
  status = 'open';
}
